// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?v=" + {"vendors-node_modules_dompurify_dist_purify_js":"97051dca99074b3dd5d9","vendors-node_modules_canvg_lib_index_es_js":"10a6843c53c068f63c79"}[chunkId] + "";
};